import { render, staticRenderFns } from "./NewTrading.vue?vue&type=template&id=5a27a597&scoped=true&"
import script from "./NewTrading.vue?vue&type=script&lang=js&"
export * from "./NewTrading.vue?vue&type=script&lang=js&"
import style0 from "./NewTrading.vue?vue&type=style&index=0&id=5a27a597&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a27a597",
  null
  
)

export default component.exports